import { ReactNode } from 'react';
import { Input, Select } from '@iwoca/orion';
import { t } from '@lingui/macro';
import { TSignupFormDataDE } from 'components/Signup/NewSignupFormDE/NewSignupFormDE.types';
import { useFormContext } from 'react-hook-form';
import { DE_LEGAL_FORM_VALUES } from 'utils/applications/signup.config';
import formStyles from '../../../NewSignupFormDE.module.css';
import styles from './ManualCompanyInputDE.module.css';

type TProps = {
  labelComponent: ReactNode;
};

export const ManualCompanyInputDE = ({ labelComponent }: TProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<TSignupFormDataDE>();

  return (
    <>
      <div>
        {labelComponent}
        <Input
          className={styles.manualInput}
          id="company.name"
          {...register('company.name')}
          error={errors?.company?.name?.message}
          placeholder="z.B. Muster Firma"
          data-testid="company-name"
        />
      </div>

      <div className={formStyles.inlineInputFields}>
        <div className={formStyles.inlineInputSpan}>
          <Input
            {...register('company.street')}
            id="street"
            label={t`Street`}
            data-testid="company-street"
            placeholder="z.B. Schildgasse"
            error={errors?.company?.street?.message}
          />
        </div>
        <Input
          {...register('company.buildingNumber')}
          id="buildingNumber"
          label={t`House number`}
          data-testid="company-house-number"
          placeholder="z.B. 21"
          error={errors?.company?.buildingNumber?.message}
        />
      </div>

      <div className={formStyles.inlineInputFields}>
        <Input
          {...register('company.postcode')}
          id="postcode"
          label={t`Postcode`}
          data-testid="company-postcode"
          placeholder="z.B. 37269"
          error={errors?.company?.postcode?.message}
        />

        <div className={formStyles.inlineInputSpan}>
          <Input
            {...register('company.town')}
            id="town"
            label={t`Town`}
            data-testid="company-town"
            placeholder="z.B. Waldmünchen"
            error={errors?.company?.town?.message}
          />
        </div>
      </div>

      <div className={formStyles.inputField}>
        <Select
          {...register('company.legalForm')}
          id="legalForm"
          label={t`Legal form`}
          placeholder={t`Select an option`}
          error={errors?.company?.legalForm?.message}
        >
          {DE_LEGAL_FORM_VALUES.map((formType) => (
            <option key={formType.value} value={formType.value}>
              {formType.label}
            </option>
          ))}
        </Select>
      </div>
    </>
  );
};
